export default "__VITE_ASSET__BlJMY1sn__"